<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">随時処理</div>
    <div v-if="isOpen" class="dropdown-menu">
      <!-- <router-link  to="#"  class="dropdown-item"  @click="redirectToManage">会社情報</router-link>
      <router-link to="/role" class="dropdown-item" @click="closeDropdown" v-if="companyService.role && companyService.role.includes('Admin')">役割</router-link>
      <router-link to="/master/staffList" class="dropdown-item" @click="closeDropdown">スタッフマスター</router-link>
      <router-link to="/master/userList" class="dropdown-item" @click="closeDropdown">利用者マスター</router-link>
      <router-link to="/master/officeList" class="dropdown-item" @click="closeDropdown"> 事業所マスター</router-link>
      <router-link to="/master/syohinList" class="dropdown-item" @click="closeDropdown">商品マスター</router-link>
      <router-link to="/master/tani" class="dropdown-item" @click="closeDropdown">単位マスター</router-link>-->
      <!-- <router-link
        to="/userMemo"
        class="dropdown-item"
        @click="closeDropdown"
        >利用者メモ</router-link
      > -->
      <button class="dropdown-item" @click="openInNewTab('/userMemo')">利用者メモ</button>

      <router-link to="/image" class="dropdown-item" @click="closeDropdown"
        >画像管理</router-link
      >

      <router-link to="/careplanRenkeiImport" class="dropdown-item" @click="closeDropdown"
        >ケアプランデータ取得</router-link
      >

      <router-link to="/serviceUsageTable" class="dropdown-item" @click="closeDropdown"
        >サービス提供票入力</router-link
      >
      <router-link
        to="/serviceUsageJissekiTable"
        class="dropdown-item"
        @click="closeDropdown"
        >サービス実績票入力</router-link
      >

      <router-link to="/serviceTeikyohyo" class="dropdown-item" @click="closeDropdown"
        >サービス提供票</router-link
      >

      <router-link to="/serviceJissekihyo" class="dropdown-item" @click="closeDropdown"
        >サービス実績票</router-link
      >

      <router-link to="/careplanRenkeiExport" class="dropdown-item" @click="closeDropdown"
        >ケアプランデータ出力</router-link
      >

      <router-link to="/userUsage" class="dropdown-item" @click="closeDropdown"
        >記録入力</router-link
      >

      <router-link to="/userUsageList" class="dropdown-item" @click="closeDropdown"
        >記録書一覧</router-link
      >

      <router-link to="/userHutan" class="dropdown-item" @click="closeDropdown"
        >利用者負担入力</router-link
      >

      <router-link to="/userVitalSight" class="dropdown-item" @click="closeDropdown"
        >バイタルサイングラフ</router-link
      >

      <router-link to="/homonKaigoKeikaku" class="dropdown-item" @click="closeDropdown"
        >訪問介護計画入力</router-link
      >

      <router-link to="/tusyoKaigoKeikaku" class="dropdown-item" @click="closeDropdown"
        >通所介護計画入力</router-link
      >

      <router-link to="/homonKangoKirokusyo" class="dropdown-item" @click="closeDropdown"
        >訪問看護記録書</router-link
      >

      <router-link to="/homonKangoKeikaku" class="dropdown-item" @click="closeDropdown"
        >訪問看護計画入力</router-link
      >

      <router-link to="/homonKangoHokoku" class="dropdown-item" @click="closeDropdown"
        >訪問看護報告入力</router-link
      >

      <router-link to="/homonKangoHokoku2" class="dropdown-item" @click="closeDropdown"
        >訪問看護報告２入力</router-link
      >

      <router-link to="/homonKangoJohoTeikyo" class="dropdown-item" @click="closeDropdown"
        >訪問看護情報提供書</router-link
      >

      <router-link to="/kagakutekiKaigoHyoka" class="dropdown-item" @click="closeDropdown"
        >科学的介護推進に関する 評価</router-link
      >

      <router-link to="/seikatuKinouCheck" class="dropdown-item" @click="closeDropdown"
        >生活機能チェックシート</router-link
      >

      <router-link to="/kyomiKansinCheck" class="dropdown-item" @click="closeDropdown"
        >興味関心チェックシート</router-link
      >

      <router-link to="/DBD13" class="dropdown-item" @click="closeDropdown"
        >DBD13</router-link
      >

      <router-link to="/icfStaging" class="dropdown-item" @click="closeDropdown"
        >ICFステージング</router-link
      >

      <router-link to="/seikatuNintikinou" class="dropdown-item" @click="closeDropdown"
        >生活・認知機能尺度</router-link
      >

      <router-link to="/kobetukinouKunren" class="dropdown-item" @click="closeDropdown"
        >個別機能訓練</router-link
      >

      <router-link to="/rihabiriKeikaku" class="dropdown-item" @click="closeDropdown"
        >リハビリテーション計画</router-link
      >

      <router-link to="/eiyoscreening" class="dropdown-item" @click="closeDropdown"
        >栄養スクリーニング・アセスメント・モニタリング
      </router-link>

      <router-link to="/eiyoCareKeikaku" class="dropdown-item" @click="closeDropdown"
        >栄養ケア計画
      </router-link>

      <router-link to="/koukouEiseiKanri" class="dropdown-item" @click="closeDropdown"
        >口腔衛生管理
      </router-link>

      <router-link to="/koukouKinouKeikaku" class="dropdown-item" @click="closeDropdown"
        >口腔機能向上計画
      </router-link>

      <router-link to="/jokusoKeikaku" class="dropdown-item" @click="closeDropdown"
        >褥瘡対策に関するスクリーニング・ケア計画
      </router-link>

      <router-link to="/haisetuKeikaku" class="dropdown-item" @click="closeDropdown"
        >排せつの状態に関するスクリーニング・支援計画
      </router-link>

      <router-link to="/jiritushienKeikaku" class="dropdown-item" @click="closeDropdown"
        >自立支援促進に関する評価 ・支援計画
      </router-link>

      <router-link to="/yakuzaiKanri" class="dropdown-item" @click="closeDropdown"
        >かかりつけ医連携薬剤調整加算・薬剤管理指導
      </router-link>

      <router-link to="/adlKasan" class="dropdown-item" @click="closeDropdown"
        >ADL維持等加算
      </router-link>

      <router-link to="/life" class="dropdown-item" @click="closeDropdown"
        >Life CSV作成
      </router-link>

      <!-- <router-link
        to="/homonKaigoKeikaku2"
        class="dropdown-item"
        @click="closeDropdown"
        >訪問介護計画入力2</router-link
      > -->

      <!-- <router-link
        to="/visitingNurseRecordII"
        class="dropdown-item"
        @click="closeDropdown"
        >訪問看護記録書Ⅱ</router-link
      >
      <router-link to="/visitingNursePlan" class="dropdown-item" @click="closeDropdown"
        >訪問看護計画書</router-link
      >
      <router-link to="/visitingNurseReport" class="dropdown-item" @click="closeDropdown"
        >訪問看護報告書</router-link
      >
      <router-link to="/counter" class="dropdown-item" @click="closeDropdown"
        >Counter</router-link
      >
      <router-link to="/fetch-data" class="dropdown-item" @click="closeDropdown"
        >Fetch data</router-link
      >
      <router-link to="/fileupload" class="dropdown-item" @click="closeDropdown"
        >FileUpload</router-link
      >
      <router-link to="/pdf" class="dropdown-item" @click="closeDropdown"
        >PDF</router-link
      >
      <router-link to="/myFullCalendar" class="dropdown-item" @click="closeDropdown"
        >FullCalendar</router-link
      > -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps, inject } from "vue";
import { RouterLink } from "vue-router";
import router from "@/router";
import CompanyService from "../Js/CompanyService";
const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。

const modal = inject("modal") as {
  showModalYesNo: (
    title: string,
    message: string,
    actionYesCallback?: () => void,
    actionNoCallback?: () => void
  ) => Promise<void>;
};

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu2: Boolean,
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
  isOpen.value = false;
};

const openInNewTab = async (path: string) => {
  const callbackYes = async () => {
    const url = router.resolve(path).href;
    window.open(url, "_blank");
    closeDropdown();
  };

  const callbackNo = async () => {
    const url = router.resolve(path).href;
    window.location.href = url; // 現在のタブで開く
    closeDropdown();
  };

  await modal.showModalYesNo(
    "利用者メモ",
    "別タブで開きますか？",
    callbackYes,
    callbackNo
  );
};

watch(
  () => props.isOpenMenu2,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item {
  padding: 8px;
  display: block;
  color: black;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
